import { CreateAccountAutomationTemplate } from '../../containers/account/CreateAccountAutomationTemplate';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';

export function AdminAccountNewAutomationPage() {
	return (
		<AdminDashboardPageLayout>
			<CreateAccountAutomationTemplate />
		</AdminDashboardPageLayout>
	);
}
